<template>
  <div class="uk-flex uk-flex-column uk-flex-middle">
    <div class="uk-flex uk-flex-row uk-margin uk-width-1-1">
      <label
        class="uk-width-1-2 dcs-radio-box"
        :class="{ 'dcs-selected': deliveryMethod == 'email' }"
      >
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 71.4 50.6" width="70.704" height="50" v-if="theme === 'blue'" v-bind:svg-inline="''" v-bind:class="'uk-margin'" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M66.254 40.6V6.3c0-3.5-2.9-6.3-6.4-6.3h-48.6c-3.5 0-6 2.6-6 6.3v34.3h-5.3v3.2c0 3.7 3 6.7 6.7 6.7h57.8c3.9 0 7-3.2 7-7v-2.9h-5.2z" fill="#fff"/><g fill="#124b68"><path d="M66.254 40.6V6.3c0-3.5-2.9-6.3-6.4-6.3h-48.6c-3.5 0-6 2.6-6 6.3v34.3h-5.3v3.2c0 3.7 3 6.7 6.7 6.7h57.8c3.9 0 7-3.2 7-7v-2.9h-5.2zM7.054 6.3c0-2.7 1.7-4.5 4.2-4.5h48.5c2.5-.1 4.6 1.9 4.7 4.4v34.4h-2.8v-36h-51.8v36h-2.8V6.3zm52.7.2v34.2h-48.1V6.5h48.1zm9.9 35.9v1.1c0 2.9-2.3 5.2-5.2 5.2h-57.7c-2.7 0-4.9-2.2-4.9-4.9v-1.4"/><path d="M29.354 46.5h12.8c.5 0 .9-.3 1-.8s-.3-.9-.8-1h-13c-.5 0-.9.5-.8 1 0 .4.4.7.8.8zM27.254 34.7h16.9c1 0 1.7-.8 1.7-1.7V22c0-1-.8-1.7-1.7-1.7h-11.4v-3c.3-1.7 1.9-2.9 3.7-2.6 1.3.2 2.3 1.3 2.6 2.6v.8h2.4v-.7c0-2.7-2.5-5-5.5-5s-5.5 2.2-5.5 5v2.9h-3c-1 0-1.7.8-1.7 1.7v11c-.2.9.6 1.7 1.5 1.7zm8.7-10.8c1.2 0 2.2 1 2.2 2.2 0 .6-.2 1.2-.7 1.6v1.7c0 .9-.7 1.5-1.5 1.5s-1.5-.7-1.5-1.5v-1.7c-.9-.8-.9-2.2 0-3.1.3-.5.9-.7 1.5-.7z"/></g></svg>
        <svg xmlns="http://www.w3.org/2000/svg" width="70.704" height="50" viewBox="0 0 70.704 50" v-else="" v-bind:svg-inline="''" v-bind:class="'uk-margin'" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><g data-name="Group 4024"><path data-name="Path 7162" d="M65.5 40.152V6.265A6.313 6.313 0 0059.038.004H11.161C7.676.004 5.2 2.578 5.2 6.265v33.887H0v3.182a6.666 6.666 0 006.666 6.67h57.069a6.969 6.969 0 006.965-6.973v-2.879zM6.969 6.265c0-2.727 1.616-4.444 4.141-4.444h47.928a4.545 4.545 0 014.646 4.444v33.887h-2.777V4.598H9.8v35.554H6.969zm52.17.152v33.735H11.565V6.366zm9.747 35.6v1.061a5.151 5.151 0 01-5.151 5.151H6.666a4.848 4.848 0 01-4.848-4.845V41.97" fill="#09c"/><path data-name="Path 7163" d="M29.039 45.96h12.626a.909.909 0 100-1.768H29.039a.909.909 0 100 1.768z" fill="#09c"/><path data-name="Path 7164" d="M27.019 34.294h16.666a1.717 1.717 0 001.717-1.717V21.668a1.717 1.717 0 00-1.717-1.667H32.372v-3.03a3.13 3.13 0 016.161 0v.753h2.424v-.6c0-2.727-2.475-4.9-5.5-4.9s-5.5 2.172-5.5 4.9v2.879h-2.938a1.717 1.717 0 00-1.717 1.716v10.858a1.717 1.717 0 001.717 1.717zm8.535-10.707a2.172 2.172 0 011.515 3.737v1.717a1.54 1.54 0 01-3.081 0v-1.717a2.172 2.172 0 011.514-3.737z" fill="#f86821"/></g></svg>

        <div class="uk-text-center dcs-email-delivery">
          <input
            type="radio"
            value="email"
            class="uk-radio uk-visible@m"
            :checked="deliveryMethod == 'email'"
            @click="onSelect('email')"
          />
          Email (fastest method)
        </div>
      </label>
      <label
        class="uk-width-1-2 dcs-radio-box"
        :class="{ 'dcs-selected': deliveryMethod == 'paper_mail' }"
      >
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 56.2 56.2" width="70.704" height="50" v-if="theme === 'blue'" v-bind:svg-inline="''" v-bind:class="'uk-margin'" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M56.2 26.2V26c0-.1 0-.1-.1-.2v-.1l-.1-.1-.1-.1c-.1 0-.1-.1-.1-.1l-8.3-6.6c-.2-.2-.3-.4-.3-.6V3.1c0-1.7-1.4-3.1-3.1-3.1h-32C10.4 0 9 1.4 9 3.1v15.1c0 .3-.1.5-.3.6L.5 25.4l-.1.1c-.1 0-.1.1-.1.1l-.1.1c-.1.1 0 .1 0 .1 0 .1-.1.1-.1.2V51.8c0 2.4 2 4.4 4.4 4.4h47.3c2.4 0 4.4-2 4.4-4.4V26.4v-.2z" fill="#fff"/><g fill="#124b68"><path d="M56.2 26.2V26c0-.1 0-.1-.1-.2v-.1l-.1-.1-.1-.1c-.1 0-.1-.1-.1-.1l-8.3-6.6c-.2-.2-.3-.4-.3-.6V3.1c0-1.7-1.4-3.1-3.1-3.1h-32C10.4 0 9 1.4 9 3.1v15.1c0 .3-.1.5-.3.6L.5 25.4l-.1.1c-.1 0-.1.1-.1.1l-.1.1c-.1.1 0 .1 0 .1 0 .1-.1.1-.1.2V51.8c0 2.4 2 4.4 4.4 4.4h47.3c2.4 0 4.4-2 4.4-4.4V26.4v-.2zm-9.1-3.4c0-.3.2-.6.5-.8.3-.1.6-.1.9.1l4.2 3.4c.4.3.4.8.1 1.2l-.2.2-4.1 2.9c-.1.1-.3.1-.5.1-.1 0-.3 0-.4-.1-.3-.1-.4-.4-.4-.7v-6.3zM11 3.1c0-.6.5-1.2 1.1-1.2H44c.6 0 1.1.5 1.1 1.2v28.5c0 .3-.1.5-.4.7l-13.6 9.4H31c-.9.6-2 .9-3.1 1-1.1-.1-2.1-.4-3.1-1 0 0-.1 0-.1-.1l-13.6-9.4c-.2-.2-.4-.4-.4-.7L11 3.1zM3.5 25.5l4.2-3.4c.4-.3.9-.2 1.2.1.1.1.2.3.2.5V29c0 .5-.4.8-.8.8-.2 0-.3-.1-.5-.1l-4.3-2.8c-.4-.3-.5-.8-.2-1.2l.2-.2zm50.7 26.2c0 1.4-1.1 2.5-2.5 2.5h-6.6c-.5 0-.8-.4-.8-.8 0-.2.1-.4.2-.6l2.3-2.3c.4-.4.4-1 0-1.4-.4-.4-1-.4-1.4 0L40.5 54c-.2.2-.4.2-.6.2h-5.7c-.5 0-.8-.4-.8-.8 0-.2.1-.4.2-.6l2.3-2.3c.4-.4.4-1 0-1.4-.4-.4-1-.4-1.4 0L29.6 54c-.2.2-.4.2-.6.2h-5.7c-.5 0-.8-.4-.8-.8 0-.2.1-.4.2-.6l2.3-2.3c.4-.4.4-1 0-1.4-.4-.4-1-.4-1.4 0L18.7 54c-.2.2-.4.2-.6.2h-5.7c-.5 0-.8-.4-.8-.8 0-.2.1-.4.2-.6l2.3-2.3c.4-.4.4-1 0-1.4-.4-.4-1-.4-1.4 0L7.8 54c-.2.2-.4.2-.6.2h-3c-1.4 0-2.5-1.1-2.5-2.5v-22c0-.3.2-.6.4-.7.3-.1.6-.1.9.1l20.7 14.3s.1 0 .1.1c1.2.8 2.6 1.2 4.1 1.2 1.4-.1 2.8-.5 4.1-1.2 0 0 .1 0 .1-.1l20.7-14.3c.3-.2.6-.2.9-.1.3.1.4.4.4.7v22z"/><path d="M24.5 12.8h7.2c.5 0 1-.5.9-1 0-.5-.4-.9-.9-.9h-7.2c-.5 0-1 .5-.9 1-.1.5.4.9.9.9zM19.1 20h18.1c.5 0 1-.4 1-1 0-.5-.4-1-1-1H19.1c-.5 0-1 .4-1 1s.4 1 1 1zM19.1 27.3h18.1c.5 0 1-.4 1-.9s-.4-1-.9-1H19.1c-.5 0-1 .4-1 .9s.4.9 1 1c-.1 0-.1 0 0 0z"/></g></svg>
        <svg xmlns="http://www.w3.org/2000/svg" width="56" height="56" viewBox="0 0 56 56" v-else="" v-bind:svg-inline="''" v-bind:class="'uk-margin'" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><g data-name="Group 4027"><g data-name="Group 4026"><path data-name="Path 7169" d="M55.969 26.1a1.033 1.033 0 00-.039-.189.941.941 0 00-.078-.179c-.015-.027-.028-.054-.04-.081s-.038-.04-.055-.061a.967.967 0 00-.139-.133.747.747 0 01-.14-.147L47.3 18.771a.824.824 0 01-.312-.648V3.112A3.1 3.1 0 0043.919 0H12.083a3.1 3.1 0 00-3.074 3.112v15.011a.822.822 0 01-.312.648L.53 25.3a.821.821 0 01-.15.156.962.962 0 00-.141.136c-.017.02-.034.04-.053.058s-.026.055-.041.083a.851.851 0 00-.077.178.876.876 0 00-.039.189 1.149 1.149 0 01-.031.174v25.3A4.428 4.428 0 004.423 56h47.154A4.428 4.428 0 0056 51.577v-25.3a1.168 1.168 0 01-.031-.177zm-8.978-3.36a.832.832 0 01.47-.747.842.842 0 01.877.1l4.192 3.353a.829.829 0 01-.046 1.33l-4.19 2.9a.827.827 0 01-.472.147.844.844 0 01-.386-.094.828.828 0 01-.444-.735zM10.954 3.112a1.164 1.164 0 011.129-1.167h31.836a1.163 1.163 0 011.127 1.167v28.379a.83.83 0 01-.358.682l-13.552 9.382a.888.888 0 01-.081.05 6.422 6.422 0 01-3.054.962 6.428 6.428 0 01-3.054-.961.707.707 0 01-.086-.052l-13.55-9.381a.829.829 0 01-.357-.682zM3.471 25.446l4.191-3.353a.829.829 0 011.347.647V29a.829.829 0 01-1.3.682l-4.193-2.9a.828.828 0 01-.045-1.329zm50.584 26.131a2.481 2.481 0 01-2.478 2.478h-6.615a.829.829 0 01-.585-1.416l2.328-2.329a.974.974 0 000-1.375 1 1 0 00-1.375 0l-4.876 4.878a.838.838 0 01-.587.243h-5.715a.829.829 0 01-.586-1.416l2.328-2.329a.974.974 0 000-1.375 1 1 0 00-1.374 0l-4.878 4.878a.838.838 0 01-.587.243H23.34a.829.829 0 01-.586-1.416l2.329-2.33a.973.973 0 000-1.375.994.994 0 00-1.374 0l-4.878 4.878a.836.836 0 01-.587.243h-5.715a.829.829 0 01-.586-1.416l2.33-2.33a.975.975 0 000-1.375 1 1 0 00-1.375 0L8.02 53.812a.836.836 0 01-.586.243H4.423a2.481 2.481 0 01-2.478-2.478v-21.94a.826.826 0 01.445-.737.84.84 0 01.856.053l20.6 14.258a.888.888 0 00.094.056A8.545 8.545 0 0028 44.513a8.539 8.539 0 004.066-1.244 1.007 1.007 0 00.094-.056l20.594-14.258a.841.841 0 01.857-.052.825.825 0 01.444.734z" fill="#09c"/><path data-name="Path 7170" d="M23.933 12.956h8.134a1.1 1.1 0 000-2.2h-8.134a1.1 1.1 0 000 2.2z" fill="#f86821"/><path data-name="Path 7171" d="M17.832 20.131h20.336a1.1 1.1 0 100-2.2H17.832a1.1 1.1 0 100 2.2z" fill="#f86821"/><path data-name="Path 7172" d="M17.832 27.304h20.336a1.1 1.1 0 100-2.2H17.832a1.1 1.1 0 100 2.2z" fill="#f86821"/></g></g></svg>

        <div class="uk-text-center dcs-paper-mail-delivery">
          <input
            type="radio"
            value="paper_mail"
            class="uk-radio uk-visible@m"
            :checked="deliveryMethod == 'paper_mail'"
            @click="onSelect('paper_mail')"
          />
          Paper Mail
        </div>
      </label>
    </div>
    <div>
      <div v-if="isEmail" class="uk-grid uk-grid-small">
        <content-section content-key="email-consent-disclaimer" :law="law" />
        <div
          class="uk-width-1-1 uk-form-controls"
          :class="{
            'dcs-has-error': $v.emailAddress.$dirty && $v.emailAddress.$invalid
          }"
        >
          <label>Email Address</label>
          <input
            :value="emailAddress"
            type="text"
            name="email"
            class="uk-input dcs-input"
            @input="
              $emit('update:emailAddress', $event.target.value);
              $v.emailAddress.$touch();
            "
          />

          <div
            class="uk-text-danger"
            v-if="$v.emailAddress.$dirty && $v.emailAddress.$invalid"
          >
            Please enter a valid email address.
          </div>
        </div>

        <div
          class="uk-width-1-1 uk-form-controls"
          :class="{
            'dcs-has-error':
              $v.emailAddressConfirm.$dirty && $v.emailAddressConfirm.$invalid
          }"
        >
          <label>Confirm Email Address</label>
          <input
            v-model="$v.emailAddressConfirm.$model"
            type="text"
            name="email_confirm"
            class="uk-input dcs-input"
            autocomplete="email"
            @input="$v.emailAddressConfirm.$touch()"
          />

          <div
            class="uk-text-danger"
            v-if="
              $v.emailAddressConfirm.$dirty && $v.emailAddressConfirm.$invalid
            "
          >
            Does not match the address above!
          </div>
        </div>
      </div>
    </div>
    <div v-if="isPaperMail" class="uk-width-1-1">
      <address-form
        :mailingAddress="mailingAddress"
        :v="$v.mailingAddress"
        @update="onUpdateMailingAddress"
      />
    </div>
  </div>
</template>

<script>
import AddressForm from "./elements/AddressForm";
import ContentSection from "./elements/ContentSection";
import {
  email,
  required,
  requiredIf,
  sameAs,
  numeric,
  minLength,
  maxLength,
  helpers
} from "vuelidate/lib/validators";

const isPaperMail = requiredIf(function() {
  return this.isPaperMail;
});
const isEmail = requiredIf(function() {
  return this.isEmail;
});
const validateIf = (prop, validator) =>
  helpers.withParams({ type: "validatedIf", prop }, function(value) {
    return this[prop] ? validator(value) : true;
  });

export default {
  name: "delivery-method-form",
  props: ["theme", "deliveryMethod", "emailAddress", "mailingAddress", "law"],
  components: { AddressForm, ContentSection },
  data: function() {
    return {
      emailAddressConfirm: null
    };
  },
  methods: {
    onSelect: function(value) {
      this.$emit("update:deliveryMethod", value);
    },
    onUpdateMailingAddress: function(value) {
      this.$emit("update:mailingAddress", value);
    }
  },
  created: function() {
    this.$watch("$v.$invalid", () => {
      this.$emit("validated", this.$v);
    });
  },
  computed: {
    isEmail: function() {
      return this.deliveryMethod == "email";
    },
    isPaperMail: function() {
      return this.deliveryMethod == "paper_mail";
    }
  },
  validations: {
    deliveryMethod: {
      required
    },
    emailAddress: {
      requiredIf: isEmail,
      email
    },
    emailAddressConfirm: {
      requiredIf: isEmail,
      email,
      sameAs: sameAs("emailAddress")
    },
    mailingAddress: {
      firstName: { requiredIf: isPaperMail },
      lastName: { requiredIf: isPaperMail },
      line1: { requiredIf: isPaperMail },
      line2: {},
      region: { requiredIf: isPaperMail },
      city: { requiredIf: isPaperMail },
      postal_code: {
        requiredIf: isPaperMail,
        numeric: validateIf("isPaperMail", numeric),
        minLength: validateIf("isPaperMail", minLength(5)),
        maxLength: validateIf("isPaperMail", maxLength(5))
      }
    }
  }
};
</script>

<style scoped></style>
